<div class="tire-add-dialog">
  <div class="tire-header mb-0">
    <div class="ui-g-12 flex-between-center py-0">
      <div class="flex-start-center width-100p">
        <div class="pl-1 tire-description width-100p p-relative">
          <p class="m-0 font-secondary-700 font-16 font-600 ">Create / edit category</p>
        </div>
        <i id="tire-close-dialog" class="far fa-times pointer dialog-close" (click)="handleCloseModal()"></i>
      </div>
    </div>
  </div>

  <!-- Start Add Tire Body -->
  <div class="ui-g tire-body pt-0 pb-0 border-bottom-light">
    <div class="ui-g-12 inputs-column-spacing tire-inner-body">
      <div class="ui-g-12 p-0 width-100p flex-between-center">
        <div class="search-bar-width">
          <div class="font-12 font-400 font-black text-container">
            <div class="pl-1 cat-type">Category type</div>
            <div class="pl-1 itm-type">Item type</div>
          </div>

          <app-list-filter [options]="headerOptions" [preAppliedFilter]="preAppliedFilter"
            (filterChange)="filterChange($event)">
          </app-list-filter>
        </div>
        <div class="flex-end-center">
        </div>
      </div>



      <div class="ui-g-12 p-0 mt-2 mb-2 width-100p flex-between-center">
        <div class="search-bar-width">
          <span class="font-14 font-700 ml-2 pointer">Categories</span>
          <button class="btn btn-create btn-submit ml-3" (click)="handleCreateNewCategory(true)">
            <i class="fal fa-plus mr-4p"></i>
            <span>New</span>
          </button>
        </div>
        <div class="flex-end-center">
        </div>
      </div>

      <!-- Create Category button -->
      <div class="ui-g-12 flex-between-center p-0" *ngIf="isShowNewCategory">
        <div class="ui-g-4">
          <div class="category-container ml-2 pb-0">
            <div class="category-search-accordion-wrapper">
              <div class="category-search-header-btn">
                <i class="fal fa-chevron-down"></i>
                <div class="width-100p">
                  <app-input id="category-name" type="text" [placeholder]="typePlaceholder[categoryItemType]"
                    theme="light" maxLength="1000" [fontSize]="14" [autoFocus]="true" [errorMessage]=""
                    [value]="categoryData.categoryName" [floatingLabel]="true"
                    (appChange)="handleChangeCategory('categoryName',$event)">
                  </app-input>
                </div>
              </div>
            </div>
          </div>
          <div class="flex-end-center pt-2 ">
            <div>
              <button class="btn btn-border pointer btn-submit mr-1"
                (click)="handleCreateNewCategory(false)">Cancel</button>
              <button class="btn btn-primary btn-submit" (click)="createCategory()">
                <span>Create</span>
                <i *ngIf="isLoading" class="far fa-spinner rotate"></i>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="isLoading" class="ml-3 font-primary"><i class="far fa-spinner rotate"></i><span class="ml-2"></span>
      </div>
      <div class="category-container" *ngFor="let category of categories; let i = index">
        <div id="accordion">
          <div class="category-search-accordion-wrapper">
            <div class="btn btn-link hover-list">
              <div class="width-50p category-search-header-btn">
                <span class="pointer p-1 font-14  font-400"
                  (click)="categoryAccordion(category); getSubcategories(category, i)">
                  <i class="fal" [ngClass]="[!category?.isCollapse ? 'fa-chevron-right' : 'fa-chevron-down']"></i>
                  <span class="font-black">{{category?.categoryName}} </span>
                </span>
                <div class="flex-start-center">
                  <span class="ml-3"><i class="far fa-plus action-icons pointer" pTooltip="Create new subcategory"
                      tooltipPosition="top" (click)="openSubCategory(true,category, 'create',i)"></i></span>
                  <span class="ml-3"><i class="far fa-pen action-icons pointer" pTooltip="Edit category name"
                      tooltipPosition="top" (click)="opneEditCategoryName(category,'update',i)"></i></span>
                  <span class="pl-2 seprate-icons font-gray-35">|</span>
                  <span class="ml-3">
                    <i class="fas fa-trash action-icons pointer" pTooltip="Delete category" tooltipPosition="top"
                      (click)="deleteCategory('category', category?._id, category, subCategory)"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Updating Category button -->
        <div class="ui-g-12 mb-0 pb-0 flex-between-center p-0"
          *ngIf="isShowEditCategory && (category.categoryId === selectedCategory)">
          <div class="ui-g-4 mt-2 ml-2 mb-0 pb-0">
            <div class="category-container ml-2 pb-0">
              <div class="category-search-accordion-wrapper">
                <div class="category-search-header-btn">
                  <i class="fal fa-chevron-down"></i>
                  <div class="width-100p">
                    <app-input id="category-name" type="text" [placeholder]="typePlaceholder[categoryItemType]"
                      theme="light" maxLength="1000" [fontSize]="14" [errorMessage]="" [autoFocus]="true"
                      [value]="categoryData.categoryName" [floatingLabel]="true"
                      (appChange)="handleChangeCategory('categoryName',$event)">
                    </app-input>
                  </div>
                </div>
              </div>
            </div>
            <div class="flex-end-center pt-2 pb-2 ">
              <div>
                <button class="btn btn-border pointer btn-submit mr-1"
                  (click)="cancelEditCategory(item)">Cancel</button>
                <button class="btn btn-submit btn-primary" (click)="handleUpdateCategory()">
                  <span>Update</span>
                  <i *ngIf="isLoading" class="far fa-spinner rotate"></i>
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- category-container start  -->
        <!-- <div *ngIf="isSubCategotiesLoading" class="ml-3 font-primary"><i class="far fa-spinner rotate"></i><span class="ml-2"></span></div>   -->
        <div *ngIf="category.isCollapse && (category.categoryId === selectedCategory)">

          <div class="category-search-item-wrapper" *ngIf="!isSubCategotiesLoading">
            <!-- Create Sub categories -->
            <div class="ui-g-4 category-container ml-2 pb-0"
              *ngIf="isShowSubCategory && (category.categoryId === selectedCategory)">
              <div class="category-search-accordion-wrapper">
                <div class="category-search-header-btn">
                  <i class="fal fa-chevron-down"></i>
                  <div class="width-100p">
                    <app-input id="category-name" type="text" [placeholder]="subTypePlaceholder[categoryItemType]"
                      theme="light" maxLength="1000" [fontSize]="14" [autoFocus]="true" [errorMessage]=""
                      [value]="categoryData.subCategoryName" [floatingLabel]="true"
                      (appChange)="handleChangeCategory('subCategoryName',$event)">
                    </app-input>
                  </div>
                </div>
              </div>
              <div class="flex-end-center pt-2">
                <div>
                  <button class="btn btn-border pointer btn-submit mr-1"
                    (click)="openSubCategory(false, category, 'update', i)">Cancel</button>
                  <button class="btn btn-primary btn-submit" (click)="createSubCategory(category,category?.categoryId)">
                    <span>Create</span>
                    <i *ngIf="isLoading" class="far fa-spinner rotate"></i>
                  </button>
                </div>
              </div>
            </div>

            <div class="category-container" *ngFor="let subCategory of subCategories; let j = index">
              <div id="accordion">
                <div class="category-search-accordion-wrapper">
                  <div class="btn btn-link hover-list">
                    <div class="width-50p category-search-header-btn">
                      <span class="pointer p-1"
                        (click)="subCategoryAccordion(subCategory); getSubSubcategories(category,subCategory,j)">
                        <i class="fal"
                          [ngClass]="[!subCategory?.isCollapse ? 'fa-chevron-right' : 'fa-chevron-down']"></i>
                        <span>{{subCategory?.subCategoryName}} </span>
                      </span>
                      <div class="flex-start-center">
                        <span class="ml-3"><i class="far fa-plus action-icons pointer"
                            pTooltip="Create new sub subcategory" tooltipPosition="top"
                            (click)="openNewSubsubCategory(true, 'create', category, subCategory, j)"></i></span>
                        <span class="ml-3"><i class="far fa-pen action-icons pointer" pTooltip="Edit subcategory name"
                            tooltipPosition="top"
                            (click)="handleEditSubCategory(category, subCategory, 'update', true)"></i></span>
                        <span class="pl-2 seprate-icons font-gray-35">|</span>
                        <span class="ml-3">
                          <i class="fas fa-trash action-icons pointer" pTooltip="Delete category" tooltipPosition="top"
                            (click)="deleteCategory('subCategory', subCategory?._id, category, subCategory)"></i>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Edit Sub categories -->
              <div class="ui-g-4 category-container ml-2 pb-0"
                *ngIf="isShowEditSubCategory && (subCategory.subCategoryId === selectedSubCategory)">
                <div class="category-search-accordion-wrapper">
                  <div class="category-search-header-btn">
                    <i class="fal fa-chevron-down"></i>
                    <div class="width-100p">
                      <app-input id="category-name" type="text" [placeholder]="subTypePlaceholder[categoryItemType]"
                        theme="light" maxLength="1000" [fontSize]="14" [autoFocus]="true" [errorMessage]=""
                        [value]="categoryData.subCategoryName" [floatingLabel]="true"
                        (appChange)="handleChangeCategory('subCategoryName',$event)">
                      </app-input>
                    </div>
                  </div>
                </div>
                <div class="flex-end-center pt-2 pb-2 ">
                  <div>
                    <button class="btn btn-border pointer btn-submit mr-1"
                      (click)="openSubCategory(false, category, 'create', i)">Cancel</button>
                    <button class="btn btn-primary btn-submit"
                      (click)="updateSubCategory(category,category?.categoryId)" *ngIf="subCategoryType === 'update'">
                      <span>Update</span>
                      <i *ngIf="isLoading" class="far fa-spinner rotate"></i>
                    </button>
                  </div>
                </div>
              </div>

              <!--Sub category-container start  -->
              <div *ngIf="subCategory.isCollapse && (subCategory.subCategoryId === selectedSubCategory)">
                <div class="category-search-item-wrapper">
                  <!-- Create Sub sub categories -->
                  <div class="ui-g-4 category-container"
                    *ngIf="isShowSubsubCategory && (subCategory.subCategoryId === selectedSubCategory)">
                    <div class="category-search-accordion-wrapper">
                      <div class="category-search-header-btn">
                        <i class="fal fa-chevron-down"></i>
                        <div class="width-100p">
                          <app-input id="category-name" type="text"
                            [placeholder]="subSubTypePlaceholder[categoryItemType]" theme="light" maxLength="1000"
                            [fontSize]="14" [autoFocus]="true" [errorMessage]=""
                            [value]="categoryData.subSubCategoryName" [floatingLabel]="true"
                            (appChange)="handleChangeCategory('subSubCategoryName',$event)">
                          </app-input>
                        </div>
                      </div>
                    </div>
                    <div class="flex-end-center pt-2 pb-2 ">
                      <div>
                        <button class="btn btn-border pointer btn-submit mr-1"
                          (click)="openNewSubsubCategory(false,'create',category,subCategory,j)">Cancel</button>
                        <button class="btn btn-primary btn-submit" (click)="createSubSubCategory(category,subCategory)">
                          <span>Create</span>
                          <i *ngIf="isLoading" class="far fa-spinner rotate"></i>
                        </button>
                      </div>
                    </div>
                  </div>




                  <div class="category-container" *ngFor="let subSubCategory of subSubCategories; let k = index">
                    <div id="accordion">
                      <div class="category-search-accordion-wrapper">
                        <div class="btn btn-link hover-list">
                          <div class="width-50p category-search-header-btn">
                            <span><span class="dot ml-2"></span>{{subSubCategory?.subSubCategoryName || ''}}</span>
                            <div class="flex-start-center">
                              <span class="ml-3">
                                <i class="far fa-pen action-icons pointer" pTooltip="Edit sub subcategory name"
                                  tooltipPosition="top"
                                  (click)="openEditSubsubCategory(true,'update',category,subCategory,subSubCategory,k)"></i>
                              </span>
                              <span class="pl-2 seprate-icons font-gray-35">|</span>
                              <span class="ml-3">
                                <i class="fas fa-trash action-icons pointer" pTooltip="Delete category"
                                  tooltipPosition="top"
                                  (click)="deleteCategory('subSubCategory', subSubCategory?._id, category, subCategory)"></i>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Edit Sub subcategories -->
                    <div class="ui-g-4 category-container"
                      *ngIf="isShowEditSubsubCategory && (subSubCategory.subSubCategoryId === selectedSubSubCategory)">
                      <div class="category-search-accordion-wrapper">
                        <div class="category-search-header-btn">
                          <i class="fal fa-chevron-down"></i>
                          <div class="width-100p">
                            <app-input id="category-name" type="text"
                              [placeholder]="subSubTypePlaceholder[categoryItemType]" theme="light" maxLength="1000"
                              [fontSize]="14" [autoFocus]="true" [errorMessage]=""
                              [value]="categoryData.subSubCategoryName" [floatingLabel]="true"
                              (appChange)="handleChangeCategory('subSubCategoryName',$event)">
                            </app-input>
                          </div>
                        </div>
                      </div>
                      <div class="flex-end-center pt-2 pb-2 ">
                        <div>
                          <button class="btn btn-border pointer btn-submit mr-1"
                            (click)="openSubCategory(false, category, 'create', i)">Cancel</button>
                          <button class="btn btn-primary btn-submit"
                            (click)="updateSubSubCategory(category,subCategory)">
                            <span>Update</span>
                            <i *ngIf="isLoading" class="far fa-spinner rotate"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>


                </div>
              </div>
            </div>

          </div>
        </div>
        <!-- category-container end  -->
      </div>


    </div>
